/* eslint-disable @typescript-eslint/no-empty-function */
import { deprecatedStyled, deprecatedTheme } from "src/styles/stitches/deprecated-theme";

import * as R from "ramda";
import { useEffect, useState } from "react";
import { fetchQuoteInfo } from "src/backApi/fetchQuoteInfo";
import { FileIcon } from "src/components/Icons/FileIcon";
import { FileDownloadButton } from "src/components/buttons/FileDownloadButton";

const Container = deprecatedStyled("div", {
  borderTop: "1px solid #E0E0E0",
  marginTop: 18,
  padding: 48,
});

const TitleWrapper = deprecatedStyled("div", {
  display: "flex",
  alignItems: "center",
  marginBottom: 18,
});

const Title = deprecatedStyled("div", {
  fontWeight: 700,
  fontSize: 16,
  color: deprecatedTheme.colors.gray900,
  display: "flex",
  marginLeft: 10,
});

type DocumentsRelatedToContractProps = {
  quoteId: string;
};

const LEGAL_LINKS = {
  CGU: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/CGU_dalma_fr.pdf",
  FIC: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/FIC_NI_Dalma_fr.pdf",
  PRIVACY_POLICY_URL:
    "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/Dalma-Politique_de_confidentialite.pdf",
  IPID: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/IPID_Dalma_fr.pdf",
} as const;

function buildLegalURL(
  rcContractId: string | undefined | null,
  documentType: keyof typeof LEGAL_LINKS
) {
  if (rcContractId) {
    return R.replace("RC_CONTRACT_ID", rcContractId, LEGAL_LINKS[documentType]);
  }
  return R.replace("/RC_CONTRACT_ID", "", LEGAL_LINKS[documentType]);
}

export const DocumentsRelatedToContract = ({ quoteId }: DocumentsRelatedToContractProps) => {
  const [rcContractId, setRcContractId] = useState<string | null>(null);

  useEffect(() => {
    if (quoteId) {
      fetchQuoteInfo(
        quoteId,
        (response) => {
          setRcContractId(response?.data[0]?.rc_contract_id);
        },
        () => {}
      );
    }
  }, [quoteId]);

  return (
    <Container>
      <TitleWrapper>
        <FileIcon color="#585B66" />
        <Title>Fiche DIPA</Title>
      </TitleWrapper>
      <a rel="noopener noreferrer" target="_blank" href={buildLegalURL(rcContractId, "IPID")}>
        <FileDownloadButton title="Fiche DIPA" format="PDF (230 ko)" />
      </a>

      <TitleWrapper>
        <FileIcon color="#585B66" />
        <Title>Notice d’information et Fiche information client</Title>
      </TitleWrapper>
      <a rel="noopener noreferrer" target="_blank" href={buildLegalURL(rcContractId, "FIC")}>
        <FileDownloadButton
          title="Notice d’information et Fiche information client"
          format="PDF (230 ko)"
        />
      </a>
    </Container>
  );
};
